// Tokens de marca / shell (color, gradiente y fondo hero por defecto). Desde
// ADR-035 salen del registro de marcas (`lib/brands`): la marca activa se fija
// en build con NEXT_PUBLIC_BRAND, así que estas constantes siguen siendo
// literales estables dentro de cada despliegue.
//
// Viven aquí —y NO en `lib/character-themes.ts`— para que las superficies
// genéricas (legales, checkout, pago, loading, …) no dependan del registro de
// personajes. Este módulo solo importa lib/brands (que solo importa
// lib/locale-prefix), así que sigue siendo seguro desde cualquier capa.

import { getBrand } from '@/lib/brands'
import { PACK_STYLES, type PackPalette } from '@/lib/pack-styles'

const theme = getBrand().theme

/**
 * Color del chrome del navegador (`themeColor` del viewport) y del splash
 * nativo. DEBE mantenerse en sync con el splash, que conserva el literal:
 *   - `capacitor.config.ts` → `plugins.SplashScreen.backgroundColor`
 *   - `scripts/generate-splash.ts` → `BACKGROUND`
 * Ver DESIGN.md → «A converger» #3.
 */
export const BRAND_THEME_COLOR = theme.themeColor

/**
 * Gradiente de fondo del *shell* en páginas no específicas de un personaje
 * (legales, checkout, pago, not-found, loading, home). Clase Tailwind completa
 * (literal en lib/brands/registry.ts). Ver DESIGN.md §7.2.
 */
export const BRAND_GRADIENT = theme.shellGradient

/** Fondo sólido genérico de hero/video mock. */
export const HERO_BG_DEFAULT = theme.heroBg

/**
 * Paleta de las superficies de compra dentro de la app (selector de packs y
 * modal de checkout): la de `PACK_STYLES` que la marca elige con
 * `theme.packVariant`, la MISMA tabla que viste `LandingPricing`. Visten la
 * marca, no el personaje; el pack destacado sigue siendo ámbar en todas. Ver
 * DESIGN.md §7.2.
 */
export const BRAND_PAYWALL: PackPalette = PACK_STYLES[theme.packVariant]

/** Gradiente y color de borde de la tarjeta de saldo del dashboard (superficie clara). */
export const BRAND_BALANCE_CARD = theme.balanceCard
